"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceSchemaProperties = exports.ZapierInvoiceSchema = exports.InvoiceSchema = exports.CreditSchema = exports.InvoiceKindEnum = exports.InvoiceMethodEnum = exports.FrequencySchema = exports.InvoiceItemSchema = exports.InvoiceCustomFieldSchema = exports.InvoiceStatusEnum = void 0;
const lodash_1 = require("lodash");
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const client_schema_1 = require("./client-schema");
const intuit_realm_1 = require("./intuit-realm");
const schema_properties_interface_1 = require("./schema-properties-interface");
const smart_action_schema_1 = require("./smart-action-schema");
exports.InvoiceStatusEnum = zod_1.z.enum([
    "open",
    "draft",
    "shared",
    "scheduled",
    "viewed",
    "paid",
    "void",
    "failed",
    "deleted",
    "processing",
    "refunded",
    "partially_refunded",
    "cancelled",
]);
exports.InvoiceCustomFieldSchema = zod_1.z.object({
    title: zod_1.z.string(),
    value: zod_1.z.string(),
});
exports.InvoiceItemSchema = zod_1.z.object({
    productId: zod_1.z.string().optional(),
    description: zod_1.z.string(),
    quantity: zod_1.z.string().or(zod_1.z.number()).transform(lodash_1.toNumber),
    unitAmount: zod_1.z.number().min(0),
    itemAmount: zod_1.z.number().min(0),
    taxTypeId: zod_1.z.string(),
    taxAmount: zod_1.z.number().min(0),
    taxInclusive: zod_1.z.boolean(),
    transactionId: zod_1.z.string().optional(),
    addedAt: zod_1.z.date().optional(),
});
exports.FrequencySchema = zod_1.z.object({
    interval: zod_1.z.string(),
    intervalCount: zod_1.z.number().optional(),
    paymentCount: zod_1.z.number().optional(),
});
exports.InvoiceMethodEnum = zod_1.z.enum(["manual", "auto"]);
exports.InvoiceKindEnum = zod_1.z.enum([
    "usage-based",
    "accounts-payable",
    "package-payment",
]);
exports.CreditSchema = zod_1.z.object({
    description: zod_1.z.string(),
    amount: zod_1.z.number(),
    addedAt: zod_1.z.date(),
    paymentIntentId: zod_1.z.string().optional(),
    refundId: zod_1.z.string().optional(),
    type: zod_1.z.enum(["subscription", "initial-deposit"]).optional(),
});
exports.InvoiceSchema = base_schema_1.BaseSchema.extend({
    payeeId: zod_1.z.string(),
    contactId: zod_1.z.string(),
    couponId: zod_1.z.string().optional(),
    status: exports.InvoiceStatusEnum,
    dueDate: zod_1.z.date().optional(),
    cutoffDate: zod_1.z.date().optional(),
    dueAfterDays: zod_1.z.number().optional(),
    currency: zod_1.z.string(),
    amount: zod_1.z.number(),
    tax: zod_1.z.number().min(0).optional(),
    discount: zod_1.z.number().min(0).optional(),
    total: zod_1.z.number(),
    recurring: exports.FrequencySchema.optional(),
    subscriptionId: zod_1.z.string().optional(),
    memo: zod_1.z.string().optional(),
    footer: zod_1.z.string().optional(),
    customFields: zod_1.z.array(exports.InvoiceCustomFieldSchema).optional(),
    items: zod_1.z.array(exports.InvoiceItemSchema).optional(),
    stripe: zod_1.z
        .object({
        customer: zod_1.z.any(),
    })
        .optional(),
    invoice: zod_1.z.any(),
    subscription: zod_1.z.string().optional(),
    scheduledSmartActions: zod_1.z.array(zod_1.z.string()).optional(),
    sendAt: zod_1.z.date().optional(),
    smartActionTemplates: zod_1.z.array(smart_action_schema_1.SmartActionTemplateSchema).optional(),
    isUpcomingInvoice: zod_1.z.boolean().optional(),
    wasScheduled: zod_1.z.boolean().optional(),
    paymentMethod: zod_1.z.string().optional(),
    paidAt: zod_1.z.date().optional(),
    productId: zod_1.z.string().optional(),
    quickBooks: intuit_realm_1.IntuitQuickBooksInvoiceInfoSchema.optional(),
    approval: zod_1.z
        .object({
        approvedAt: zod_1.z.date(),
        approvedBy: zod_1.z.string(),
    })
        .optional()
        .nullable(),
    packageInstanceId: zod_1.z.string().nullable().optional(),
    invoiceMethod: exports.InvoiceMethodEnum.optional(),
    pendingTransactions: zod_1.z.array(zod_1.z.string()).optional(),
    memberId: zod_1.z.string().optional(),
    kind: exports.InvoiceKindEnum.optional(),
    credits: zod_1.z.array(exports.CreditSchema).optional(),
    minimumAmount: zod_1.z.number().optional(),
    paymentNeedsAttention: zod_1.z.boolean().optional(),
    cancelled: zod_1.z
        .object({
        cancelledAt: zod_1.z.date(),
        cancelledBy: zod_1.z.string(),
    })
        .optional(),
});
/**
 * Schema for an invoice as it is sent across the wire.
 */
exports.ZapierInvoiceSchema = zod_1.z.object({
    id: zod_1.z.string(),
    number: zod_1.z.string(),
    total: zod_1.z.number(),
    currency: zod_1.z.string(),
    client: client_schema_1.ZapierClientSchema,
});
exports.InvoiceSchemaProperties = {
    collectionName: "invoices",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=invoice-schema.js.map